import { Component } from '@angular/core';

@Component({
    selector: 'vp-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['../errors.scss'],
    standalone: false
})
export class Error404Component {}
